"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayRatiosModel = /** @class */ (function () {
    function PayRatiosModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/pay-ratios",
            UPDATE: APPURL + "/api/v1/pay-ratios",
            CREATE: APPURL + "/api/v1/pay-ratios",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    PayRatiosModel.prototype.extract = function (result) {
        return result.data;
    };
    PayRatiosModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    PayRatiosModel.prototype.getByID = function (id) {
        return this.$http.get(this.URLS.FETCH + "/" + id).then(this.cacheResults);
    };
    PayRatiosModel.prototype.get = function () {
        return this.$http.get(this.URLS.FETCH).then(this.cacheResults);
    };
    PayRatiosModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    PayRatiosModel.prototype.updateCollection = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/6/collection", request)
            .then(this.cacheResults);
    };
    PayRatiosModel.prototype.insert = function (request) {
        return this.$http.post(this.URLS.FETCH, request).then(this.cacheResults);
    };
    PayRatiosModel.prototype.remove = function (user) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + user.id)
            .then(this.cacheResults);
    };
    return PayRatiosModel;
}());
PayRatiosModel.$inject = ["$http", "APPURL"];
exports.default = PayRatiosModel;
